/* unplugin-vue-components disabled */import { render } from "./DetailsSection.vue?vue&type=template&id=36a7b93c&scoped=true&ts=true"
import script from "./DetailsSection.vue?vue&type=script&lang=ts"
export * from "./DetailsSection.vue?vue&type=script&lang=ts"

import "./DetailsSection.vue?vue&type=style&index=0&id=36a7b93c&scoped=true&lang=scss"
import "./DetailsSection.vue?vue&type=style&index=1&id=36a7b93c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a7b93c"]])

export default __exports__